import { render, staticRenderFns } from "./ClienteTabPrecoB2BEmpresaModal.vue?vue&type=template&id=469b2a5c&scoped=true"
import script from "./ClienteTabPrecoB2BEmpresaModal.vue?vue&type=script&lang=js"
export * from "./ClienteTabPrecoB2BEmpresaModal.vue?vue&type=script&lang=js"
import style0 from "./ClienteTabPrecoB2BEmpresaModal.vue?vue&type=style&index=0&id=469b2a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469b2a5c",
  null
  
)

export default component.exports